// ** React Basics
import { React, useState } from "react"
import { useNavigate } from "react-router-dom"
// ** Reactstrap Imports
import { Col, Label, Row } from "reactstrap"
// ** Utils
import { provideOptionsToSelect } from "@lib/util"
// ** Third Party Components
import AsyncSelect from "react-select/async"
// ** API calls
import { Search } from "react-feather"

const InitialClientSearch = () => {
  const navigate = useNavigate()
  const [debounce, setDebounce] = useState(null)

  // ** Functions
  const onChangeHandler = (value) => {
    if (value) {
      navigate(`/CRM/Visits/${value.value}`)
    }
  }

  // manual debounce to avoid multiple requests while typing
  const promiseOptions = (inputSearchValue) => {
    return new Promise((resolve) => {
      setDebounce(
        setTimeout(() => {
          resolve(
            provideOptionsToSelect(
              {
                name: `Persons?filters[discriminator]=Person&limit=25&light=true&search=${inputSearchValue}`,
                apiEndpoint: "crm"
              },
              ["name", "firstName", "addresses[0].postCode"]
            )
          )
        }, 800)
      )
    })
  }

  return (
    <Row>
      <Col>
        <h2 className="text-primary">Search</h2>
        <hr style={{ height: "1px" }} />
        <Label className="form-label" for="client-search-input">
          <Search size={16} /> Search for a client
        </Label>

        <AsyncSelect
          isClearable={false}
          className="react-select"
          classNamePrefix="select"
          placeholder="Name or Last Name..."
          noOptionsMessage={() => "Search by name or last name"}
          loadOptions={(inputSearchValue) => {
            clearTimeout(debounce)
            return promiseOptions(inputSearchValue)
          }}
          cacheOptions
          autoFocus
          onChange={onChangeHandler}
          defaultOptions
        />
      </Col>
    </Row>
  )
}

export default InitialClientSearch
